import Vue from 'vue';
import Vuex from 'vuex';
import apiService from '@/services/apiService';
import { TokenService } from '@/services/storageService';

import internalUserModule from '../views/app/menu/superadmin/routes/internal-user/store/index';

import cxModule from '../views/app/menu/cx/routes/cx-report/store/index';
import cxAutoClaim from '../views/app/menu/cx/routes/cx-auto-claim/store/index';
import cxInstantClaim from '../views/app/menu/cx/routes/cx-instant-claim/store/index';
import cxFoodClaim from '../views/app/menu/cx/routes/cx-food-claim/store/index';
import cxCorporateClaim from '../views/app/menu/cx/routes/cx-corporate-claim/store/index';
import ClaimSettingPINSettingModule from '../views/app/menu/cx/routes/claim-setting/pin-setting/store/index';
import ClaimSettingPaymentLimitationModule from '../views/app/menu/cx/routes/claim-setting/payment-limitation/store/index';
import ClaimSettingDisbursementTimeModule from '../views/app/menu/cx/routes/claim-setting/payment-disbursement-time/store/index';
import ClaimExcessModule from '../views/app/menu/cx/routes/claim-excess/store/index';

import AboutusModule from '../views/app/menu/marketing/routes/aboutus/routes/content/store/index';
import BannerAboutusModule from '../views/app/menu/marketing/routes/aboutus/routes/banner/store/index';
import OurServiceModule from '../views/app/menu/marketing/routes/our_service/routes/content/store/index';
import BannerOurServiceModule from '../views/app/menu/marketing/routes/our_service/routes/banner/store/index';
import TncContentModule from '../views/app/menu/marketing/routes/tnc/routes/content/store/index';
import TncCategoryModule from '../views/app/menu/marketing/routes/tnc/routes/category/store/index';
import FaqModule from '../views/app/menu/marketing/routes/faq/store/index';
import ArticleModule from '../views/app/menu/marketing/routes/article/store/index';
import PrivacypolicyModule from '../views/app/menu/marketing/routes/privacypolicy/store/index';
import homePageModule from '../views/app/menu/marketing/routes/home_page/store/index';
import NewUserPromoModule from '../views/app/menu/marketing/routes/newuserpromo/store/index';
import OnBoardingScreenModule from '../views/app/menu/marketing/routes/onboardingscreen/store/index';
import RefferalPartnerModule from '../views/app/menu/marketing/routes/refferalpartner/store/index';
import ShowCaseModule from '../views/app/menu/marketing/routes/showcase/store/index';
import DonasiModule from '../views/app/menu/marketing/routes/donasi/store/index';
import ExtraPackagingModule from '../views/app/menu/marketing/routes/extrapackaging/store/index';
import RatingModule from '../views/app/menu/marketing/routes/rating/store/index';
import ReportRefferalModule from '../views/app/menu/marketing/routes/report_refferal/store/index';
import GeneralSettingsModule from '../views/app/menu/marketing/routes/general_settings/store/index';
// import PaxelMarketModule from '../views/app/menu/marketing/routes/paxel_market/store/index';
import PaxelcoDashboardModule from '../views/app/menu/marketing/routes/dashboard/store/index';
import FootnoteModule from '../views/app/menu/marketing/routes/footnote/store/index';
import customerListModule from '../views/app/menu/marketing/routes/mitra_paxel/routes/customer-list/store/index';
import BannerModule from '../views/app/menu/marketing/routes/mitra_paxel/routes/banner/store/index';
import CaptchaModule from '../views/app/menu/marketing/routes/captcha/store/index';

import bannerLockerModule from '../views/app/menu/marketing/routes/locker_microsite/routes/banner_locker/store/index';
import servicesLockerModule from '../views/app/menu/marketing/routes/locker_microsite/routes/services_locker/store/index';
import guestBookModule from '../views/app/menu/marketing/routes/locker_microsite/routes/guest_book/store/index';

import CorpSalesBannerModule from '../views/app/menu/marketing/routes/corp_sales/routes/banner/store/index';
import CorpSalesExcellenceModule from '../views/app/menu/marketing/routes/corp_sales/routes/corp_sales_excellence/store/index';
import CorpSalesTestimonialModule from '../views/app/menu/marketing/routes/corp_sales/routes/corp_sales_testimonial/store/index';
import CorpSalesPartnerModule from '../views/app/menu/marketing/routes/corp_sales/routes/partner_list/store/index';

import PaxelBigBannerModule from '../views/app/menu/marketing/routes/paxel_big/routes/banner/store/index';
import FlowModule from '../views/app/menu/marketing/routes/paxel_big/routes/flow/store/index';
import PaxelBigExcellenceModule from '../views/app/menu/marketing/routes/paxel_big/routes/excellence/store/index';
import PaxelBigCustomerModule from '../views/app/menu/marketing/routes/paxel_big/routes/customer_list/store/index';
import PaxelBigRegistrationButtonModule from '../views/app/menu/marketing/routes/paxel_big/routes/registration_button/store/index';

import PaxelMarketMainHeaderModule from '../views/app/menu/marketing/routes/paxel_market/routes/main_header/store/index';
import PaxelMarketMetaModule from '../views/app/menu/marketing/routes/paxel_market/routes/meta/store/index';
import PaxelMarketBasicServiceModule from '../views/app/menu/marketing/routes/paxel_market/routes/basic_service/store/index';
import PaxelMarketMainFeaturesModule from '../views/app/menu/marketing/routes/paxel_market/routes/main_features/store/index';
import PaxelMarketJoinProcedureModule from '../views/app/menu/marketing/routes/paxel_market/routes/join_procedure/store/index';
import PaxelMarketPartnersModule from '../views/app/menu/marketing/routes/paxel_market/routes/partners/store/index';
import PaxelMarketSOPModule from '../views/app/menu/marketing/routes/paxel_market/routes/sop/store/index';

import TransactionLogModule from '../views/app/menu/finance/routes/transaction_log/store/index';

import PaymentMethodModule from '../views/app/menu/finance/routes/payment_method/store/index';
import BannerDownloadModule from '../views/app/menu/marketing/routes/download/routes/banner/store/index';

import MembersModule from '../views/app/menu/marketing/routes/paxelin_club/routes/member/store/index';
import EventModule from '../views/app/menu/marketing/routes/paxelin_club/routes/event/store/index';
import PointSalesModule from '../views/app/menu/marketing/routes/paxelin_club/routes/point_sales/store/index';
import ClaimedBenefitModule from '../views/app/menu/marketing/routes/paxelin_club/routes/claimed_benefit/store/index';
import BenefitCategoryModule from '../views/app/menu/marketing/routes/paxelin_club/routes/benefit_category/store/index';
import BenefitTypeModule from '../views/app/menu/marketing/routes/paxelin_club/routes/benefit_type/store/index';
import BenefitModule from '../views/app/menu/marketing/routes/paxelin_club/routes/benefit/store/index';

import MessageServiceModule from '../views/app/menu/message_service/routes/message_log/store/index';
import MessageSettingsModule from '../views/app/menu/message_service/routes/message_settings/store/index';
import CLick2BuyModule from '../views/app/menu/marketing/routes/click2buy/store/index';
import ShortenerServiceModule from '../views/app/menu/shortener_service/routes/shortener_url/store/index';

import PaxelRecycleMetaModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/meta/store/index';
import PaxelRecycleBannerModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/banner/store/index';
import PaxelRecycleReasonModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/reason/store/index';
import PaxelRecycleWasteTypeModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/waste_type/store/index';
import PaxelRecycleBeforeSendingModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/before_sending/store/index';
import PaxelRecycleHowToModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/how_to/store/index';
import PaxelRecycleTutorialModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/tutorial/store/index';
import PaxelRecycleCoverageModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/coverage/store/index';
import PaxelRecycleMoreInfoModule from '../views/app/menu/marketing/routes/paxel_recycle/routes/more_info/store/index';
import PejuangOnlineBannerModule from '../views/app/menu/marketing/routes/pejuang_online/routes/banner/store/index';

import MasterProviderModule from '../views/app/menu/ppob/routes/master_provider/store/index';
import PPOBProductModule from '../views/app/menu/ppob/routes/ppob_product/store/index';
import PPOBTransactionModule from '../views/app/menu/ppob/routes/ppob_transaction/store/index';

import ReserveModule from '../views/app/menu/marketing/routes/promo/routes/reservation_log/store/index';
import VoucherModule from '../views/app/menu/marketing/routes/promo/routes/voucher/store/index';
import MyVoucherTabModule from '../views/app/menu/marketing/routes/promo/routes/my_voucher_tab/store/index';
import ImageURLGeneratorModule from '../views/app/menu/marketing/routes/promo/routes/image_url_generator/store/index';
import SpecialVoucherModule from '../views/app/menu/marketing/routes/promo/routes/special_voucher/store/index';

import GlobalSearchModule from '../views/app/menu/marketing/routes/global_search/store/index';

import ErrorLogModule from '../views/app/menu/developer/routes/error_log/store/index';
import GuideBookModule from '../views/app/menu/developer/routes/guide_book/store/index';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    cxModule,
    cxAutoClaim,
    cxInstantClaim,
    cxFoodClaim,
    cxCorporateClaim,
    TncContentModule,
    TncCategoryModule,
    FaqModule,
    ArticleModule,
    homePageModule,
    AboutusModule,
    PrivacypolicyModule,
    OurServiceModule,
    NewUserPromoModule,
    OnBoardingScreenModule,
    RefferalPartnerModule,
    internalUserModule,
    ShowCaseModule,
    DonasiModule,
    ExtraPackagingModule,
    RatingModule,
    ReportRefferalModule,
    GeneralSettingsModule,
    PaxelcoDashboardModule,
    PaymentMethodModule,
    TransactionLogModule,
    customerListModule,
    BannerModule,
    bannerLockerModule,
    servicesLockerModule,
    guestBookModule,
    CorpSalesBannerModule,
    CorpSalesExcellenceModule,
    CorpSalesTestimonialModule,
    CorpSalesPartnerModule,
    PaxelBigBannerModule,
    PaxelMarketMainHeaderModule,
    PaxelMarketMetaModule,
    PaxelMarketBasicServiceModule,
    PaxelMarketMainFeaturesModule,
    PaxelMarketJoinProcedureModule,
    PaxelMarketPartnersModule,
    PaxelMarketSOPModule,
    FlowModule,
    PaxelBigExcellenceModule,
    PaxelBigCustomerModule,
    BannerAboutusModule,
    BannerOurServiceModule,
    FootnoteModule,
    CaptchaModule,
    BannerDownloadModule,
    PaxelBigRegistrationButtonModule,
    MembersModule,
    EventModule,
    PointSalesModule,
    ClaimedBenefitModule,
    MessageServiceModule,
    MessageSettingsModule,
    CLick2BuyModule,
    ShortenerServiceModule,
    BenefitCategoryModule,
    BenefitTypeModule,
    BenefitModule,
    PaxelRecycleMetaModule,
    PaxelRecycleBannerModule,
    PaxelRecycleReasonModule,
    PaxelRecycleWasteTypeModule,
    PaxelRecycleBeforeSendingModule,
    PaxelRecycleHowToModule,
    PaxelRecycleTutorialModule,
    PaxelRecycleCoverageModule,
    PaxelRecycleMoreInfoModule,
    PejuangOnlineBannerModule,
    MasterProviderModule,
    PPOBProductModule,
    PPOBTransactionModule,
    VoucherModule,
    GlobalSearchModule,
    MyVoucherTabModule,
    ImageURLGeneratorModule,
    SpecialVoucherModule,
    ReserveModule,
    ClaimSettingPINSettingModule,
    ClaimSettingPaymentLimitationModule,
    ClaimSettingDisbursementTimeModule,
    ClaimExcessModule,
    ErrorLogModule,
    GuideBookModule
  },
  state: {
    token: localStorage.getItem('access_token') || null,
    item_type: [],
    isGoogleInit: false,
    googleUser: {}
  },
  getters: {
    loggedIn(state) {
      return state.token !== null;
    },
  },
  mutations: {
    retrieveToken(state, token) {
      state.token = token;
    },
    destroyToken(state) {
      state.token = null;
    },
    getItemtype: (state, item_type) => {
      state.item_type = item_type;
    },
    storeIsGoogleInit(state, bool) {
      state.isGoogleInit = bool;
    },
    storeGoogleUser(state, data) {
      state.googleUser = data;
    }
  },
  actions: {
    setIsGoogleInit({ commit }, bool) {
      commit("storeIsGoogleInit", bool);
    },
    setGoogleUser({ commit }, data) {
      commit("storeGoogleUser", data);
    },
    getItemtype({ commit }) {
      apiService.get('additional-info/item-type')
        .then((response) => {
          commit('getItemtype', response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    destroyToken(context) {
      if (context.getters.loggedIn) {
        return new Promise((resolve, reject) => {
          apiService.post('logout', {
            access_token: context.getters.loggedIn,
          })
            .then((response) => {
              TokenService.removeToken();
              TokenService.removeRefreshToken();
              apiService.removeHeader();
              context.commit('destroyToken');
              resolve(response);
              console.log(response);
            })
            .catch((error) => {
              TokenService.removeToken();
              TokenService.removeRefreshToken();
              apiService.removeHeader();
              context.commit('destroyToken');
              console.log(error);
              reject(error);
            });
        });
      }
    },
    retrieveToken(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/user/login', payload)
          .then((response) => {
            if (response.data.code === 200) {
              context.commit('retrieveToken', response.data.data);
              resolve(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    forgotpass(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/user/forgot-password', payload)
          .then((response) => {
            if (response.data.code === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    uploadAws(context, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/third-party/upload-image', payload)
          .then((response) => {
            if (response.data.code === 200) {
              resolve(response);
            }
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    googleLogin({ commit }, payload) {
      /**
       * payload : {
       *    "client_id": "",
       *    "jwt_token": ""
       * }
       */
      return new Promise((resolve, reject) => {
        apiService
          .post(`${process.env.VUE_APP_API_MANAGER}/api/v1/googlelogin`, payload)
          .then((response) => {
            Vue.prototype.$session.set("jwt", response.data.data);
            localStorage.setItem("device_id", response.data.data.device_info.id);
            commit("retrieveToken", response.data.data);
            resolve(response.data.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    googleLogout({ commit }, payload) {
      return new Promise((resolve, reject) => {
        apiService
          .post(`${process.env.VUE_APP_API_MANAGER}/api/v1/googlelogout`, payload)
          .then((response) => {
            Vue.prototype.$session.destroy();
            TokenService.removeToken();
            TokenService.removeRefreshToken();
            apiService.removeHeader();
            commit('destroyToken');
            resolve(response);
          })
          .catch((error) => {
            Vue.prototype.$session.destroy();
            TokenService.removeToken();
            TokenService.removeRefreshToken();
            apiService.removeHeader();
            commit('destroyToken');
            reject(error);
          });
      });
    },
    claimSubmitPINVerification({ commit }, payload) {
      return new Promise((resolve, reject) => {
        apiService.post('/cx/claim-setting/pin/verification', payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
});
